module.exports = __webpack_public_path__ + "img/product_bulk_upload_note.58a0ba2c.svg";